import Message from '../../../shared/Message';

const MessageModal = (vm) => {
    return (
        <div
            ref={vm.messagesContainerRef}
            className="fixed right-4 z-50 flex flex-col gap-3 pointer-events-none overflow-hidden"
            style={{
            top: `${vm.topOffsetPx}px`,
            maxHeight: `${vm.maxHeightPx}px`,
            }}
        >
        {vm.messages?.map((msg) => (
            <Message
                key={msg.id}
                message={msg.text}
                type={msg.type}
                onClose={() => vm.closeMessage(msg.id)}
            />
        ))}
      </div>    
    );
};

export default MessageModal;
